module.exports = __webpack_public_path__ + "nr.68e197a2b9cc992fda33.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/nr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/nr.svg
// module chunks = styles